import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Doughnut } from 'react-chartjs-2';
import BootstrapTable from 'react-bootstrap-table-next';


class AnalysisResult extends Component {
    labelNames = [];
    numOfErrors = 0;
    numOfAlarts = [];

    constructor(props) {
        super(props);
        this.dataSource = this.props.data;
        this.setGraph();
        this.errorRow = "Error-Row";
        this.alertRow = "Alert-Row";
    }
    
    setDownloadLog(className, filename, textArray){
        var cell = document.getElementsByClassName(className)[0].children[1];
        var num = cell.innerText;
        cell.innerText = "";

        var element = document.createElement('a');
        element.textContent = num;

        var text = "";
        if(className === this.errorRow){
            text = "EMS Point Adress,EMS Point Value,System Type,Error\n";
            textArray.forEach(row =>{
                text = `${text}${row.emsPointAddress},${row.emsPointValue},${row.systemType},${row.error}\n`;
            });
        }
        else if(className === this.alertRow){
            text = "EMS Point Adress,EMS Point Value,System Type,Message\n";
            textArray.forEach(row =>{
                text = `${text}${row.emsPointAddress},${row.emsPointValue},${row.systemType},${row.message}\n`;
            });
        }

        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        cell.append(element);
    }

    componentDidMount() {
        this.setDownloadLog(this.errorRow, "ErrorLog.csv", this.dataSource.errors);
        this.setDownloadLog(this.alertRow, "AlertLog.csv", this.dataSource.alerts);
    }

    setGraph(){
        this.dataSource.analysis.forEach(element => {
            this.labelNames.push(element.systemName);
            this.numOfAlarts.push(element.numberOfAlerts);
        });
        this.numOfErrors = this.dataSource.errors.length;
    }
        
    render() {
        const data = {
            labels: this.labelNames,
            datasets: [{
                data: this.numOfAlarts,
                backgroundColor: [
                    '#194F8C',
                    '#69ccf4',
                    '#FFCD05',
                    '#008658',
                    '#6EC06a',
                    '#F04137',
                    '#6163AD',
                    '#A67C52',
                    '#F88672',
                    '#F8951E'
                ],
                borderColor: [
                    '#194F8C',
                    '#69ccf4',
                    '#FFCD05',
                    '#008658',
                    '#6EC06a',
                    '#F04137',
                    '#6163AD',
                    '#A67C52',
                    '#F88672',
                    '#F8951E'
                ],
            }]
        }

        const columns = [{
            dataField: 'systemName',
            text: 'Analysis'
        }, {
            dataField: 'numberOfAlerts',
            text: 'Total',
            classes: "Table-Total"
        }];

        const rowStyle = (row, rowIndex) => {
            const style = {};
            if (rowIndex % 2 === 0) {
                style.backgroundColor = '#F0F0F0';
            } else {
                style.backgroundColor = '#FFFFFF';
            }

            return style;
        };

        const errorData = [{
            lable: "GreenX Alerts Sent",
            num: this.dataSource.numberOfGreenXAlertsSent
        },
        {
            lable: "Errors",
            num: this.numOfErrors
        }];

        const errorColumns = [{
            dataField: 'lable',
            text: 'Alerts & Errors'
        }, {
            dataField: 'num',
            text: 'Total',
            classes: "Table-Total"
        }];

        const rowClasses = (row, rowIndex) =>{
            if(rowIndex === 0){
                return this.alertRow;
            }
            else if(rowIndex === 1){
                return this.errorRow;
            }
            else{
                return 'Extra-Row';
            }
        }

        return (
            <div className="TableGraph">
                <Row>
                    <Col lg="6">
                        <BootstrapTable keyField='id' data={ this.dataSource.analysis } columns={ columns } rowStyle={ rowStyle } />
                        <BootstrapTable keyField='id' data={ errorData } columns={ errorColumns } rowStyle={ rowStyle }  rowClasses={ rowClasses }/>
                    </Col>
                    <Col lg="6" className="Graph"><Doughnut 
                    data={data}
                    options={{
                      legend: {
                        display: true,
                        labels: {
                          fontColor: 'rgb(255, 255, 255)'
                        }
                      }
                    }}/></Col>
                </Row>
            </div>
        );
    }
}

export default AnalysisResult;